<template>
  <div>
    <!-- Desktop Navbar -->
    <transition name="fade">
      <v-app-bar
        app
        color="primary"
        dark
        class="d-none d-md-flex"
      >
        <v-app-bar-title>
          <img src="../assets/logo.png" alt="Logo" width="52" />
        </v-app-bar-title>
        <v-spacer />
        <v-btn
          v-for="item in menuItems"
          :key="item.label"
          :to="item.to"
          icon
          size="large"
          class="mx-2"
          variant="tonal"
          color="white"
          style="border-radius: 50%;"
        >
          <v-icon :icon="item.icon" />
        </v-btn>

        <v-menu v-if="moreItems.length" location="bottom" transition="scale-transition">
          <template #activator="{ props }">
            <v-btn icon v-bind="props" size="large" variant="tonal" color="white" style="border-radius: 50%;">
              <v-icon icon="mdi-menu" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="item in moreItems"
              :key="item.label"
              @click="handleItemClick(item)"
            >
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </transition>

    <!-- Mobile Bottom Navbar -->
    <transition name="fade">
      <v-bottom-navigation
        app
        color="primary"
        class="d-flex d-md-none"
      >
        <v-btn
          v-for="item in menuItems"
          :key="item.label"
          :to="item.to"
          icon
        >
          <v-icon :icon="item.icon" />
        </v-btn>

        <v-menu v-if="moreItems.length" location="top" transition="scale-transition">
          <template #activator="{ props }">
            <v-btn icon v-bind="props">
              <v-icon icon="mdi-menu" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="item in moreItems"
              :key="item.label"
              @click="handleItemClick(item)"
            >
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-bottom-navigation>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AppNavbar',
  data() {
    return {
      isLoggedIn: localStorage.getItem('isLoggedIn') === 'true'
    }
  },
  computed: {
    menuItems() {
      return [
        { label: 'Home', icon: 'mdi-home', to: '/' },
        { label: 'Files', icon: 'mdi-chart-line', to: '/list' },
        { label: 'Upload', icon: 'mdi-upload', to: '/upload' }
      ]
    },
    moreItems() {
      if (this.isLoggedIn) {
        return [
          { label: 'Settings', to: '/settings' },
          { label: 'Logout', command: this.logout }
        ]
      } else {
        return [
          { label: 'Login', to: '/login' },
          { label: 'SignUp', to: '/signup' }
        ]
      }
    }
  },
  methods: {
    handleItemClick(item) {
      if (item.command) {
        item.command()
      } else if (item.to) {
        this.$router.push(item.to)
      }
    },
    logout() {
      localStorage.removeItem('isLoggedIn')
      this.isLoggedIn = false
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
